import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { MdArticle, MdPerson, MdImage, MdViewCarousel } from "react-icons/md";
import MiniStatisticCard from "./components/MiniStatisticCard";
import RecentPosts from "./components/RecentPosts";
import QuickActions from "./components/QuickActions";
import PostsByCategory from "./components/PostsByCategory";
import UsersByRole from "./components/UsersByRole";

const Dashboard = () => {
  const [stats, setStats] = useState({
    posts: null,
    users: null,
    galleries: null,
    carousels: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const headers = { db_name: process.env.REACT_APP_DB_NAME };
        const [postsRes, usersRes, galleriesRes, carouselsRes] =
          await Promise.all([
            axios.get("/api_w/posts", { headers }),
            axios.get("/api_w/users", { headers }),
            axios.get("/api_w/galleries", { headers }),
            axios.get("/api_w/carousels", { headers }),
          ]);

        setStats({
          posts: (postsRes.data.data || []).length,
          users: (usersRes.data.data || []).length,
          galleries: (galleriesRes.data.data || []).length,
          carousels: (carouselsRes.data.data || []).length,
        });
      } catch (error) {
        toast.error("Gagal memuat statistik dashboard");
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="mt-5 grid grid-cols-1 gap-5">
      {/* Row 1: Stat Cards */}
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
        <MiniStatisticCard
          title="Total Postingan"
          value={stats.posts}
          icon={<MdArticle />}
          color="green"
          linkTo="/admin/posts"
          loading={loading}
        />
        <MiniStatisticCard
          title="Total Pengguna"
          value={stats.users}
          icon={<MdPerson />}
          color="blue"
          linkTo="/admin/user"
          loading={loading}
        />
        <MiniStatisticCard
          title="Total Galeri"
          value={stats.galleries}
          icon={<MdImage />}
          color="purple"
          linkTo="/admin/foto"
          loading={loading}
        />
        <MiniStatisticCard
          title="Total Carousel"
          value={stats.carousels}
          icon={<MdViewCarousel />}
          color="orange"
          linkTo="/admin/carousel"
          loading={loading}
        />
      </div>

      {/* Row 2: Recent Posts + Quick Actions */}
      <div className="grid grid-cols-1 gap-5 xl:grid-cols-3">
        <div className="col-span-1 xl:col-span-2">
          <RecentPosts />
        </div>
        <div className="col-span-1">
          <QuickActions />
        </div>
      </div>

      {/* Row 3: Charts */}
      <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
        <PostsByCategory />
        <UsersByRole />
      </div>
    </div>
  );
};

export default Dashboard;
